export default __webpack_public_path__ + "static/media/mob-card.26ba5b84.png";